import { Typography } from "@material-ui/core"
import { AddCircle } from "@material-ui/icons"
import PropTypes from "prop-types"
import React, { useContext } from "react"
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd"
import DarkButton from "~/components/Common/DarkButton"
import PermissionsWrapper from "~/components/Common/PermissionsWrapper"
import AppContext from "~/contexts/App"
import PathContext from "~/contexts/Path"
import AddCourseDialog from "~/dialogs/AddCourseDialog"
import Box from "../../Common/Box"
import AddedCourseCard from "../AddedCourseCard"
import NoCourseAdded from "../NoCourseAdded"
import useStyles from "./styles"

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list)
  const [removed] = result.splice(startIndex, 1)
  result.splice(endIndex, 0, removed)

  return result
}

function Course({ course, index }) {
  return (
    <Draggable draggableId={course.id.toString()} index={index}>
      {(provided) => {
        return (
          <AddedCourseCard
            course={course}
            type="view"
            index={index}
            provided={provided}
          />
        )
      }}
    </Draggable>
  )
}

const CourseList = React.memo(function CourseList({ courses }) {
  return courses?.map((course, index) => (
    <Course course={course} type="view" index={index} key={course.id} />
  ))
})

const PathCourses = () => {
  const classes = useStyles()

  const { path, courseArray, setCourseArray } = useContext(PathContext)
  const { openDialog } = useContext(AppContext)

  const handleOpen = () => {
    openDialog("addCourseDialog")
  }

  function onDragEnd(result) {
    if (!result.destination) {
      return
    }
    if (result.destination.index === result.source.index) {
      return
    }
    const courses = reorder(
      courseArray,
      result.source.index,
      result.destination.index,
    )
    setCourseArray(courses)
  }

  const disabledPath =
    (path.published || path.has_been_published) && path.archived === 0

  return (
    <Box position="relative" minHeight="100%">
      {disabledPath ? (
        <Box className={classes.publishedBanner}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            {path?.published === 1 ? (
              <Typography className={classes.title} variant="h3">
                You are in a published learning path, this cannot be updated
              </Typography>
            ) : null}
            {path?.published === 0 && path?.has_been_published === 1 ? (
              <Typography className={classes.title} variant="h3">
                You are in a unpublished learning path, this cannot be updated
              </Typography>
            ) : null}
          </Box>
        </Box>
      ) : null}
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
        padding="31px 37px 8px 37px"
        marginBottom="10px"
      >
        <Box display="flex" flexDirection="row" flexWrap="wrap">
          <Typography
            variant="h3"
            color="primary"
            style={{ fontWeight: "700", marginRight: "8px" }}
          >
            Courses
          </Typography>
          <Typography
            variant="h3"
            color="primary"
            className={classes.orderText}
          >
            In order as they appear
          </Typography>
        </Box>
        <PermissionsWrapper permissionGroup="admin">
          <DarkButton
            onClick={handleOpen}
            style={path?.published ? { display: "none" } : null}
            startIcon={
              <AddCircle
                fontSize="small"
                classes={{ root: classes.addCircle }}
              />
            }
          >
            Add Course
          </DarkButton>
        </PermissionsWrapper>
      </Box>
      <Box marginLeft={"37px"} marginRight="37px" paddingBottom="16px">
        {courseArray?.length > 0 ? (
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="course">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  <CourseList courses={courseArray} />
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        ) : (
          <NoCourseAdded />
        )}
      </Box>
      {disabledPath ? <Box className={classes.publishedOverlay} /> : null}
      <AddCourseDialog />
    </Box>
  )
}

Course.propTypes = {
  course: PropTypes.object,
  index: PropTypes.number,
}

CourseList.propTypes = {
  courses: PropTypes.array,
}

PathCourses.propTypes = {}
export default PathCourses
